export enum FORM_FIELDS {
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  MAKE = 'make',
  MILEAGE = 'mileage',
  MODEL = 'model',
  PHONE = 'phone',
  VEHICLE_TYPE = 'vehicleType',
  YEAR = 'year',
}

export type TradeInFormFields = {
  [FORM_FIELDS.EMAIL]: string
  [FORM_FIELDS.FIRST_NAME]: string
  [FORM_FIELDS.LAST_NAME]: string
  [FORM_FIELDS.MAKE]: string
  [FORM_FIELDS.MILEAGE]: string
  [FORM_FIELDS.MODEL]?: string
  [FORM_FIELDS.PHONE]: string
  [FORM_FIELDS.VEHICLE_TYPE]?: string
  [FORM_FIELDS.YEAR]: string
}
